import { ShippingFeeBreakdown } from '@/catalog/types/shipping-fee-breakdown';
import Spacer from '@/common/components/spacer';

interface DestinationFeeContentProps {
  shippingFeeBreakdown?: ShippingFeeBreakdown;
}

export default function DestinationFeeContent({
  shippingFeeBreakdown,
}: DestinationFeeContentProps) {
  return shippingFeeBreakdown !== undefined &&
    shippingFeeBreakdown.new_car_destination_fee > 0 ? (
    <div className="flex max-w-[220px] flex-col items-center justify-center">
      <p className="body3-strong text-center">
        New Car Destination Fee:{' '}
        {shippingFeeBreakdown.new_car_destination_fee <
        shippingFeeBreakdown.new_car_original_destination_fee ? (
          <>
            <s>${shippingFeeBreakdown.new_car_original_destination_fee}</s> $
            {shippingFeeBreakdown.new_car_destination_fee}
          </>
        ) : (
          <>${shippingFeeBreakdown.new_car_destination_fee}</>
        )}
      </p>
      <Spacer variant="height8" />
      <p className="body3 text-center">
        Covers shipping the vehicle from the manufacturer to Flexcar
      </p>
    </div>
  ) : null;
}
